import Collapse from '@mui/material/Collapse';
import type { Client2TrackedTranslation, Values } from '@ps/web-core-intl';
import { InfoIcon } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useCallback, useState } from 'react';

import GreenArrow from '../../assets/icons/green-arrow.svg';
import Button from '../Button/Button';

import {
  active,
  arrow,
  blueFill,
  collapseContainer,
  container,
  expandButton,
  icon
} from './CollapsiblePanel.scss';

const collapseClasses: Record<string, string> = {
  root: collapseContainer
};

interface Props {
  className?: string;
  label: Client2TrackedTranslation;
  icon?: 'info';
  values?: Values;
  blue?: boolean;
  endIconFloatRight?: boolean;
}

const CollapsiblePanel: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  icon: iconName,
  label,
  children,
  blue = false,
  ...props
}) => {
  const [expand, setExpand] = useState(false);

  const buttonClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      setExpand(!expand);
    },
    [expand, setExpand]
  );

  return (
    <div className={classNames(container, className, { [active]: expand })}>
      <Button
        firstVariant="dropdown"
        translation={label}
        endIcon={
          <GreenArrow className={classNames(arrow, { [active]: expand }, { [blueFill]: blue })} />
        }
        firstButtonIcon={
          iconName && (
            <InfoIcon className={classNames(icon, { [blueFill]: blue })} width={20} height={20} />
          )
        }
        className={expandButton}
        onClick={buttonClick}
        {...props}
      />
      <Collapse classes={collapseClasses} in={expand}>
        {children}
      </Collapse>
    </div>
  );
};

export default CollapsiblePanel;
